;(function () {

"use strict";

var CartTemplate = require('./templates/mini-cart.html');

var MiniCartQuantityView = require('./mini-cart-quantity');
var GiftWrapView = require('./gift-wrap');

var ModalView = require('./modal');
var ProductAddedModalTemplate = require('./templates/product-added-modal.html');

var ProductAddedModal = ModalView.extend({
  className: 'modal product-added',
  initialize: function (opts) {
    opts = opts || {};
    // this.parent = opts.parent;
    opts.content = _.template(ProductAddedModalTemplate)({
      product: opts.product,
      cart: opts.cart,
      remainingForFreeShipping: opts.remainingForFreeShipping
    });
    ModalView.prototype.initialize.call(this, opts);
  },
  events: _.extend({}, ModalView.prototype.events, {
    'click .continue-shopping': 'hide'
  })
});

var MiniCartView = Backbone.View.extend({
  initialize: function () {
    // console.log('init mini cart view');
    this.gift_wrapping_id = $('#global-data').data('gift-wrap-id');

    /* initial state (need to update with real data) */
    this.cart = {attributes: {
      'gift-note': $('#global-data').data('gift-wrap-note'),
      'gift-wrapping': $('#global-data').data('gift-wrapping') 
    }};

    this.blueHandUrl = $("#global-data").data('blue-hand-url');

    // this.init();
    this.first = true;
    
    var self = this;
    setTimeout(function () {
      self.render();
    }, 1000);
  },
  init: function () {
    var self = this;

    this.$el.find('.js-quantity').each(function () {
      new MiniCartQuantityView({el: this, parent: self});
    });

    this.gwv = new GiftWrapView({el: this.$el.find('.gift-wrap'), parent: this });

    /* If there are a lot of variations thers a chance the items will overlap. This will avoid that from happening by setting the height = to the taller element. */
    this.$el.find('.line-item').each(function () {
      var $li = $(this).find('> ul > li:first-child');
      var ph = $li.find('> div').height();
      var ih = $li.find('> a').height();

      if (ph > ih) {
        $li.height(ph);
      }
    });
  },
  getCart: function (cb) {
    $.getJSON('/cart.js', function (cart, textStatus) {
      cb(cart);
    });
  },
  _render: function (cart, flash) {
    this.cart = cart;

    var items = [],
        item = {},
        data = {};

    /* Remove if only line item in the cart   */
    if (this.cart.item_count === 1 && this.cart.attributes['gift-wrapping']) {
      this.gwv.remove();
      return;
    }

    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;

      if (cartItem.image !== null){
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.id,
        variant_id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, "${{amount}}"),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    var numToys = Math.round(parseInt(cart.total_price) * 0.001);
    if (numToys === 0) {
      numToys = 1;
    }

    data = {
      items: items,
      note: cart.note,
      cart: cart,
      remainingForFreeShipping: Shopify.formatMoney(15000 - cart.total_price, "${{amount}}"),
      totalPrice: Shopify.formatMoney(cart.total_price, "${{amount}}"),
      gift_wrapping: cart.attributes['gift-wrapping'],
      gift_wrapping_id: this.gift_wrapping_id,
      gift_note: cart.attributes['gift-note'],
      blueHandUrl: this.blueHandUrl,
      numToys: numToys
    };

    // console.log('rendering cart with data');
    // console.log(data);

    this.$el.find('.cart').remove();
    this.$el.find('.mask').append(_.template(CartTemplate)(data));

    var count = cart.item_count;
    if (cart.attributes['gift-wrapping']) {
      /*account for gift wrapping */
      count = count - 1;
    }

    this.$el.children('p').html('<span></span>bag('+count+')');
    /* for mobile */
    $('header ul.mobile.right li.bag a').html('bag('+count+')');

    if (cart.item_count > 0) {
      this.$el.removeClass('empty').removeClass('disabled');
    } else {
      this.$el.addClass('empty').addClass('disabled');
      $('body').removeClass('overlay');
    }

    if (!this.first) {
      this.$el.addClass('highlight');

      _.delay(_.bind(function () { this.$el.removeClass('highlight').addClass('out'); }, this), 1000);
      _.delay(_.bind(function () { this.$el.removeClass('out'); }, this), 1500);

      /* Show minicart view */
      if (flash) {
        _.delay(_.bind(function() {
          var view = window.App.dvs['mini-cart'];
          view.mouseenter();
          view.$el.addClass('hover');
        }, this), 100);

        _.delay(_.bind(function () {
          if (!this.mouseInside) {
            var view = window.App.dvs['mini-cart'];
            view.mouseleave();
          }
        }, this), 4000);

        if ($(window).width() < 765) {
          if (this.cart && this.cart.items && this.cart.items[0]) {
            new ProductAddedModal({
              product: this.cart.items[0],
              cart: cart,
              remainingForFreeShipping: Shopify.formatMoney(15000 - cart.total_price, "${{amount}}"),
            }).render().show();
            // .show();
          }
        }
      }
    } else {
      this.first = false;
    }

    this.init();

    /* only resize when vertical change occurs */
    // if (data.items.length !== this.lineitems) {
    //   this.lineitems = data.items.length;
      _.defer(function () {
        $(window).trigger('resize');
      });
    // }
  },
  render: function (flash) {
    var self = this;
    this.getCart(function (cart) {
      self._render(cart, flash);
    });
  },
  remove: function (e) {
    e.preventDefault();

    var $this = $(e.currentTarget);
    var url = $this.attr('href');

    $.post(url, _.bind(this.render, this), 'json');
  },
  mouseenter: function (e) {
    this.mouseInside = true;
  },
  mouseleave: function (e) {
    this.mouseInside = false;
  },
  events: {
    'click .cart__remove': 'remove',
    'mouseenter': 'mouseenter',
    'mouseleave': 'mouseleave'
  }
});

module.exports = MiniCartView;

}());